import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-029c82cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-pane" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = {
  key: 2,
  class: "map-copyright"
}
const _hoisted_4 = ["href"]

import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { get } from 'lodash'
import LeftLauncher from '@/components/top/LeftLauncher.vue'
import MapOL from '@/components/top/MapOL.vue'
import RainCloudController from '@/components/top/RainCloudController.vue'
import DisasterController from '@/components/top/DisasterController.vue'
import EarthquakeController from '@/components/top/EarthquakeController.vue'
import ViewSelector from '@/components/top/ViewSelector.vue'
import DataSummery from '@/components/top/DataSummery.vue'
import IconMeterPanel from '@/components/top/IconMeterPanel.vue'
import InformationLayer from '@/components/top/InformationLayer.vue'
import { useGlobalStore, TOP_VIEW_TYPES } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { LayoutInfoIconEvent } from '@/models/initData/LayoutInfo'
import { GpvLayerName } from '@/lib/olmap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const displayField = ref<string>('')
const renderLayer = ref<string>('')
const mouseonStationId = ref<string>()
const area = ref<LayoutInfoIconEvent>()
const mapRef = ref<InstanceType<typeof MapOL>>()
const showInformationLayer = ref(false)

const onEvent = (event: Event) => {
  mapRef.value?.hidePopups()
  displayField.value = get(event, ['args', 0, 'elementType', 0])
}

const onRenderModeChange = (layer: string) => {
  renderLayer.value = layer as GpvLayerName
}

const onSelectArea = (e: LayoutInfoIconEvent) => {
  area.value = e
}

const onTogglePanels = (visible: boolean) => {
  showInformationLayer.value = visible
}

const route = useRoute()
const moveByViewType = () => {
  const viewType = route.params.viewType

  if (viewType === TOP_VIEW_TYPES.SUMMARY) {
    globalStore.top.viewType = TOP_VIEW_TYPES.SUMMARY
  } else if (viewType === TOP_VIEW_TYPES.GRAPHICAL) {
    globalStore.top.viewType = TOP_VIEW_TYPES.GRAPHICAL
  }
}

const mapCopyright = computed(() => {
  return initDataStore.initData.systemInfo.mapInfo.copyright
})

const spClass = computed(() => {
  return route.params.view_type
})

const setDisplayField = () => {
  const icons = initDataStore.leftLauncherInfo(globalStore.top.viewType)?.bottom

  if (icons === undefined || icons[0] === undefined) {
    return
  }

  const icon = icons[0]
  const field = (icon.event[0].args[0]?.elementType || [])[0]

  displayField.value = field
}

const onMouseenterInfoLayer = (stationId: string) => {
  if (stationId === undefined) {
    return
  }

  mapRef.value?.highlightIcon(stationId)
}

const onMouseStation = (stationId: string) => {
  mouseonStationId.value = stationId
}

onMounted(() => {
  moveByViewType()
  setDisplayField()
})

onUnmounted(() => {
  // ページ離脱時にグラフィカル画面に戻しておく
  globalStore.top.viewType = TOP_VIEW_TYPES.GRAPHICAL
})

watch(() => route.params.viewType, moveByViewType)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(spClass), "top-view"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(globalStore).topIsGraphical)
        ? (_openBlock(), _createBlock(MapOL, {
            key: 0,
            onMouseonStation: onMouseStation,
            field: displayField.value,
            renderLayer: renderLayer.value,
            area: area.value,
            ref_key: "mapRef",
            ref: mapRef
          }, null, 8, ["field", "renderLayer", "area"]))
        : _createCommentVNode("", true),
      (_unref(globalStore).topIsSummery)
        ? (_openBlock(), _createBlock(DataSummery, {
            key: 1,
            area: area.value
          }, null, 8, ["area"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(LeftLauncher, {
      onEvent: onEvent,
      onRenderModeChange: onRenderModeChange,
      onSelectArea: onSelectArea,
      onTogglePanels: onTogglePanels
    }),
    _createElementVNode("div", _hoisted_2, [
      (_unref(globalStore).topIsGraphical && renderLayer.value == 'radar_rain')
        ? (_openBlock(), _createBlock(RainCloudController, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(globalStore).topIsGraphical && renderLayer.value == 'radar_disaster')
        ? (_openBlock(), _createBlock(DisasterController, { key: 1 }))
        : _createCommentVNode("", true),
      (_unref(globalStore).topIsGraphical && renderLayer.value == 'launcher_quake')
        ? (_openBlock(), _createBlock(EarthquakeController, {
            key: 2,
            onRenderModeChange: onRenderModeChange
          }))
        : _createCommentVNode("", true),
      (_unref(globalStore).topIsGraphical && renderLayer.value == '')
        ? (_openBlock(), _createBlock(IconMeterPanel, {
            key: 3,
            field: displayField.value
          }, null, 8, ["field"]))
        : _createCommentVNode("", true),
      (_unref(globalStore).topIsGraphical && renderLayer.value.includes('hazard'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass([renderLayer.value, "hazard-meter"])
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    (!_unref(globalStore).isSP)
      ? (_openBlock(), _createBlock(ViewSelector, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(globalStore).topIsGraphical && showInformationLayer.value)
      ? (_openBlock(), _createBlock(InformationLayer, {
          key: 1,
          onMouseenter: onMouseenterInfoLayer,
          mouseonStationId: mouseonStationId.value
        }, null, 8, ["mouseonStationId"]))
      : _createCommentVNode("", true),
    (_unref(mapCopyright) && _unref(globalStore).topIsGraphical)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("a", {
            href: _unref(mapCopyright).link,
            target: "_blank"
          }, _toDisplayString(_unref(mapCopyright).title), 9, _hoisted_4)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})